import { data } from '../../svg/Label/data';
import { makeIcon } from '../makeIcon';

export const Label = makeIcon(data, 'label', 'Label');

export default Label;
